import React, { useState } from "react";
// import { BlurView } from "@react-native-community/blur";

import {
  View,
  TouchableOpacity,
  StyleSheet,
  FlatList,
  ImageURISource,
  Image,
  KeyboardAvoidingView,
  Text,
} from "react-native";
// import CheckBox from 'expo-checkbox';
import ModalComponent from "../ModalComponent";
import GlobalStyles from "../../globalStyles/globalStyles";
import { Colors } from "../../globalStyles/ColorConfig";
import dimensions from "../../globalStyles/dimensions";
import CustomComponent from "../../components/CustomComponent";
import ExperienceIcons from "../../assets/Icons/ExperienceIcons";

type ItemProps = {
  name: string;
  code: string;
  flag: string;
};

interface SelectCountryProps {
  isDialog?: boolean;
  isVisible: boolean;
  toggleModal: () => void;

  method2: any;
  onSelectCountry: any;
}

export default function AddEmail({
  isDialog = false,
  isVisible,
  toggleModal,
  method2,
  onSelectCountry,
}: SelectCountryProps) {
  const [toggleCheckBox, setToggleCheckBox] = useState(false);

  const [gender, setGender] = useState("Male");
  const Item: React.FC<ItemProps> = ({ flag, name, code }: ItemProps) => (
    <TouchableOpacity onPress={() => onSelectCountry(code, flag)}>
      <View
        style={{
          flexDirection: "row",
          alignItems: "center",
          marginHorizontal: dimensions.marginHorizontal,
          paddingVertical: 10,
          gap: 10,
        }}
      >
        <Image
          source={{ uri: flag }}
          style={{ width: 36, height: 36, borderRadius: 50 }}
        />
        <CustomComponent.TextView
          title={name}
          textStyle={GlobalStyles.title2}
        />
      </View>
    </TouchableOpacity>
  );

  return (
    <ModalComponent isVisible={isVisible} toggleModal={toggleModal}>
      <View style={{ height: "100%", backgroundColor: "rgba(0,0,0,0.5)" }}>
        <KeyboardAvoidingView style={styles.countryContainer}>
          <View style={styles.countryHeader}>
            <CustomComponent.TextView
              title="Add email for account recovery "
              textStyle={GlobalStyles.heading3}
            />
            <TouchableOpacity onPress={method2}>
              <ExperienceIcons.Cross />
            </TouchableOpacity>
          </View>
          <View
            style={{
              flex: 1,
              paddingHorizontal: 25,
              // paddingTop: 30,
            }}
          >
            <CustomComponent.InputField
              placeholder={"Email"}
              maxLength={100}
              height={50}
              width={"100%"}
            />

            <TouchableOpacity style={styles.buttonStyle}>
              <Text style={{ color: "white" }}>Send verification link</Text>
            </TouchableOpacity>
          </View>
        </KeyboardAvoidingView>
      </View>
    </ModalComponent>
  );
}
const styles = StyleSheet.create({
  countryContainer: {
    height: "35%",
    width: "100%",
    backgroundColor: Colors.white10,
    position: "absolute",
    bottom: 0,
  },
  countryHeader: {
    flexDirection: "row",
    justifyContent: "space-between",
    paddingVertical: dimensions.paddingVertical,
    paddingHorizontal: dimensions.paddingHorizontal,
  },
  selectGender: [GlobalStyles.heading3, GlobalStyles.black90, {}],
  optionBox: {
    marginTop: 10,
  },
  optionBoxInnerBox: {
    height: 50,
    borderBottomColor: "#cac9c7",
    borderBottomWidth: 1,
    display: "flex",
    justifyContent: "space-between",
    flexDirection: "row",
    alignItems: "center",
  },
  checkBox: {
    // backgroundColor:"rgba(192, 164, 111, 1)",
  },
  optionText: [
    {
      color: "black",
      fontSize: 16,
      fontWeight: "400",
    },
  ],
  middleScreen: {
    height: "70%",
  },
  tophead: {
    height: 100,
    display: "flex",
    flexDirection: "row",
    alignItems: "center",

    columnGap: 12,
  },
  optionCircle: {
    borderWidth: 1,
    height: 30,
    width: 30,
    borderRadius: 16,
    borderColor: "#cac9c7",
  },
  optionCircleInner: {
    height: 10,
    width: 10,
    borderRadius: 7,
    backgroundColor: "white",
    zIndex: 12,
  },
  optionOnSelect: {
    backgroundColor: "rgba(192, 164, 111, 1)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  circleView: {
    height: 45,
    width: 45,
    borderRadius: 25,
    borderColor: "black",
    borderWidth: 1,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  circleViewSmall: [
    { height: 8, width: 8, borderRadius: 7, backgroundColor: "#cac9c7" },
  ],
  circleBox: {
    // flex:1
  },

  buttonStyle: {
    backgroundColor: "rgba(31, 57, 48, 1)",
    marginTop: 20,
    height: 50,
    borderRadius: 40,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
});
